export function getCookie (name) {
  let cookies = {};

  cookies = document.cookie.split('; ')
    .map(c => c.split('='))
    .reduce((a, [k, v]) => ({ ...a, [k]: decodeURIComponent(v) }), {});

  try {
    return JSON.parse(cookies[name]);
  } catch (e) {
    return cookies[name];
  }
}

export function eraseCookie (name) {
  document.cookie = `${name}=; Max-Age=0; path=/; Secure; SameSite=Strict`;
}
